exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-invalid input,\n.is-invalid input:focus,\n.is-invalid input:hover {\n  border-color: #e40909;\n}\n", ""]);

// exports
